import type { VehicleDetailsResult } from '@packages/clients';

import { toBoolean } from '@packages/core/utils';

import type { VehicleDetailsEntity } from '../entities';

/**
 * Map a `VehicleDetailsResult` DTO to a `VehicleDetailsEntity`. The shapes are currently
 * identical; this mapper establishes the DTO-to-domain boundary.
 *
 * @param dto - the VehicleDetailsResult DTO from the API
 * @returns the mapped entity
 * @example
 * ```ts
 * const entity = toVehicleDetailsEntity(apiResponse.data.results[0]);
 * ```
 */
export function toVehicleDetailsEntity(dto: VehicleDetailsResult): VehicleDetailsEntity {
    return {
        colorCategory: dto.colorCategory,
        colorDescription: dto.colorDescription,
        emissionSpec: dto.emissionSpec,
        engineId: dto.engineId,
        engineSize: dto.engineSize,
        model: dto.model,
        modelNumber: dto.modelNumber,
        modelYear: dto.modelYear,
        optionCode: dto.optionCode,
        productionDate: dto.productionDate,
        transmissionType: dto.transmissionType,
        trimDescription: dto.trimDescription,
        turboIndicator: toBoolean(dto.turboIndicator),
        vehicleTransmissionNumber: dto.vehicleTransmissionNumber,
        vin: dto.vin,
        vinStatus: dto.vinStatus,
        warrantyStartDt: dto.warrantyStartDt,
    };
}
